export default __webpack_public_path__ + "static/media/img2.faf6c325.png";